(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-card"] && !Shopify.designMode) return;
  try {
    function initReviewCards(root) {
    root.querySelectorAll('.review-card').forEach(function (card) {
      var quote = card.querySelector('.review-card__quote');
      var button = card.querySelector('.review-card__more');
      if (!quote || !button) return;
      card.classList.remove('is-expanded');
      button.textContent = 'Lire la suite';
      button.hidden = quote.scrollHeight <= quote.clientHeight + 2;
    });
  }

  function scheduleInit() {
    clearTimeout(window.__reviewCardsTimeout);
    window.__reviewCardsTimeout = setTimeout(function () {
      initReviewCards(document);
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', scheduleInit);
  window.addEventListener('resize', scheduleInit);
  document.addEventListener('shopify:section:load', scheduleInit);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.review-card__more');
    if (!button) return;
    var card = button.closest('.review-card');
    if (!card) return;
    var expanded = card.classList.toggle('is-expanded');
    button.textContent = expanded ? 'Voir moins' : 'Lire la suite';
  });

  if (document.readyState !== 'loading') {
    scheduleInit();
  }
  } catch(e) { console.error(e); }
})();

})();
